import React from 'react';
import Button from 'v3/common/components/Button';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import UserInput from 'v3/common/components/UserInput';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';

const Religare: React.FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles }) => {
  const { updatePartialConfigs, sendOtp, validateOtp, isMobile } = brokerSpecificHandles;
  const { clientId, password, otp, selectedBrokerConfig, brokerErrorMessage, isOtpSent, isLoading } =
    userConfigs;

  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-otp-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isOtpSent ? validateOtp() : sendOtp();
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-client-id`}
        value={clientId}
        onHandleChange={(value: string) => updatePartialConfigs({ clientId: value })}
        isDisabled={isOtpSent}
      />
      <UserInput
        labelValue="Password"
        id={`${broker}-password`}
        type="password"
        value={password}
        isDisabled={isOtpSent}
        onHandleChange={(value: string) => updatePartialConfigs({ password: value })}
      />
      {isOtpSent && (
        <>
          <UserInput
            labelValue="OTP"
            id={`${broker}-otp`}
            type="number"
            value={otp ?? ''}
            onHandleChange={(value: string) => updatePartialConfigs({ otp: value })}
          />
          <button type="button" onClick={() => sendOtp(true)}>
            <i className="fa-regular fa-gear fa-spin" />
            Re-Send OTP ?
          </button>
        </>
      )}

      {brokerErrorMessage && <div className="text-danger mb-2">{brokerErrorMessage}</div>}
      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-otp-form`} type="submit" isLoading={isLoading}>
          {isOtpSent ? 'Verify OTP' : 'Send OTP'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default Religare;
